import { Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQwickSilverCouponAction } from "../../redux/coupon/qwickSilverRTK";

function Google_play_left(props) {
  const vht = useSelector((state) => state.qwickSilver);
  const dispatch = useDispatch();
  let last_coupon_order_at = vht?.data?.response?.last_coupon_order_at;


  useEffect(() => {
    // fetchQwickBalance();
    console.log("props-->",props)
    dispatch(fetchQwickSilverCouponAction({ coupon: props.price,platform:props.platform=="Gamerpe"?1:2 }));
  }, [props.price,props.platform]);


  return (
    <>
      <>
        <Stack spacing={2}>
          <Stack spacing={1} direction='row'>
            <Typography>Total Uploaded Coupons</Typography>
            <Typography color='primary'>{vht?.data?.response?.coupons_count || "--"}</Typography>
          </Stack>
          <Stack spacing={1} direction='row'>
            <Typography>Amount</Typography>
            <Typography color='primary'>{props.price || "--"}</Typography>
          </Stack>
          <Stack spacing={1} direction='row'>
            <Typography>Last Coupon Order</Typography>
            <Typography color='primary'>{last_coupon_order_at || "--"}</Typography>
          </Stack>
          <Stack spacing={1} direction='row'>
            <Typography>Last Coupon Order Price</Typography>
            <Typography color='primary'>{vht?.data?.response?.last_coupon_order_price || "--"}</Typography>
          </Stack>
          <Stack spacing={1} direction='row'>
            <Typography>Coupon left</Typography>
            <Typography color='primary'>{(vht?.data?.response?.left_coupons || vht?.data?.response?.left_coupons==0)?vht?.data?.response?.left_coupons:"--"}</Typography>
          </Stack>
        </Stack>
      </>
    </>
  );
}

export default Google_play_left;
